(function () {
    const players = {};
    let apiPromise = null;

    function postStop(iframe) {
        if (!iframe || !iframe.contentWindow) return;
        const msg = JSON.stringify({ event: 'command', func: 'stopVideo', args: '' });
        try { iframe.contentWindow.postMessage(msg, '*'); } catch (_) {}
    }

    function stopVideoFor(wrapper) {
        if (!wrapper) return;
        const blockId = wrapper.dataset.videoInlineId;
        const lite = wrapper.querySelector('lite-youtube');
        const iframe = lite && lite.shadowRoot && lite.shadowRoot.querySelector('iframe');
        if (iframe) postStop(iframe);
        const p = blockId && players[blockId];
        if (p && typeof p.stopVideo === 'function') {
            try { p.stopVideo(); } catch (_) {}
        }
    }

    function loadIframeApi() {
        if (apiPromise) return apiPromise;
        apiPromise = new Promise((resolve) => {
            if (window.YT && typeof window.YT.Player === 'function') {
                resolve(window.YT);
                return;
            }
            const prev = window.onYouTubeIframeAPIReady;
            window.onYouTubeIframeAPIReady = function () {
                if (typeof prev === 'function') {
                    try { prev(); } catch (_) {}
                }
                resolve(window.YT);
            };
            // Another consumer (e.g. undergrad-degree-analytics) may have already injected the API script.
            // The chained onYouTubeIframeAPIReady above still resolves us when it finishes loading.
            if (!document.querySelector('script[src*="youtube.com/iframe_api"]')) {
                const tag = document.createElement('script');
                tag.id = 'youtube-iframe';
                tag.src = 'https://www.youtube.com/iframe_api';
                document.head.appendChild(tag);
            }
        });
        return apiPromise;
    }

    function attachPlayer(blockId, wrapper) {
        if (players[blockId]) return;
        const lite = wrapper.querySelector('lite-youtube');
        const iframe = lite && lite.shadowRoot && lite.shadowRoot.querySelector('iframe');
        if (!iframe) return;
        loadIframeApi().then((YT) => {
            if (players[blockId]) return;
            players[blockId] = new YT.Player(iframe, {
                events: { onStateChange: onStateChange },
            });
        });
    }

    function onStateChange(event) {
        if (!window.YT || event.data !== window.YT.PlayerState.PLAYING) return;
        const currentUrl = event.target.playerInfo && event.target.playerInfo.videoUrl;
        Object.entries(players).forEach(([blockId, p]) => {
            if (!p || typeof p.getVideoUrl !== 'function') return;
            if (p.getVideoUrl() === currentUrl) return;
            const wrapper = document.querySelector(
                `.coe-video-inline[data-video-inline-id="${CSS.escape(blockId)}"]`
            );
            stopVideoFor(wrapper);
        });
    }

    document.addEventListener('click', (e) => {
        const trigger = e.target.closest && e.target.closest('[data-video-inline-trigger]');
        if (trigger) {
            loadIframeApi();
            const wrapper = trigger.closest('.coe-video-inline');
            if (wrapper) wrapper.classList.add('blur-background');
            // Forward to lite-youtube so its first click activates the iframe; otherwise
            // the user would need a second click on the poster to play.
            const lite = wrapper && wrapper.querySelector('lite-youtube');
            if (lite && !lite.classList.contains('lyt-activated')) {
                lite.click();
            }
            return;
        }
        const close = e.target.closest && e.target.closest('[data-video-inline-close]');
        if (close) {
            const wrapper = close.closest('.coe-video-inline');
            if (wrapper) {
                wrapper.classList.remove('blur-background');
                stopVideoFor(wrapper);
            }
        }
    });

    document.addEventListener('liteYoutubeIframeLoaded', (e) => {
        let wrapper = e.target && e.target.closest && e.target.closest('.coe-video-inline');
        if (!wrapper && e.detail && e.detail.iframe) {
            const root = e.detail.iframe.getRootNode && e.detail.iframe.getRootNode();
            const host = root && root.host;
            if (host && host.closest) wrapper = host.closest('.coe-video-inline');
        }
        if (!wrapper) return;
        const blockId = wrapper.dataset.videoInlineId;
        if (!blockId) return;
        attachPlayer(blockId, wrapper);
    }, false);

    document.addEventListener('hide.bs.collapse', (e) => {
        const wrapper = e.target.closest && e.target.closest('.coe-video-inline');
        if (!wrapper) return;
        stopVideoFor(wrapper);
    });
})();
